module.exports = __webpack_public_path__ + "assets/img/Upload@2x.91c947c8.png";